import React from 'react'
import Page from '../../components/Page'
import PageTitle from '../../components/PageTitle'

export default () => (
  <Page>
    <PageTitle title={{ id: 'notFoundPage_heading' }} />
  </Page>
)
